import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-add-multi-project',
  templateUrl: './add-multi-project.component.html',
  styleUrl: './add-multi-project.component.css'
})
export class AddMultiProjectComponent implements OnInit {
    projectFormGroup!: FormGroup;
  roadSpecsFormGroup!: FormGroup;
  siteFormGroup!: FormGroup;
  designFormGroup!: FormGroup;
  legalFormGroup!: FormGroup;
  stakeholdersForm!: FormGroup;
  projectTeamsForm!: FormGroup;
  contractorsVendorsForm!: FormGroup;
  equipmentToolsForm!: FormGroup;
  projectControlsForm!: FormGroup;
  multiTenancyForm!: FormGroup;
  constructor(private fb: FormBuilder) {}
  ngOnInit(): void {
    this.projectFormGroup = this.fb.group({
      projectName: ['', Validators.required],
      projectType: ['', Validators.required],
      location: ['', Validators.required],
      roadClassification: ['', Validators.required],
      projectStage: ['', Validators.required],
      startDate: ['', Validators.required],
      endDate: ['', Validators.required],
      authority: ['', Validators.required]
    });

    this.roadSpecsFormGroup = this.fb.group({
      length: [null, [Validators.required, Validators.min(0.1)]],
      lanes: [null, Validators.required],
      laneWidth: [null, Validators.required],
      surfaceType: ['', Validators.required],
      designSpeed: [null, Validators.required],
      trafficVolume: [null, Validators.required],
      designLife: [null, Validators.required]
    });

    this.siteFormGroup = this.fb.group({
      terrainType: ['', Validators.required],
      soilType: ['', Validators.required],
      cbr: [null, Validators.required],
      plasticityIndex: [null],
      moistureContent: [null],
      rainfallPattern: ['', Validators.required],
      floodHistory: ['', Validators.required],
      waterTable: [null],
      temperatureRange: ['', Validators.required],
      frostSusceptibility: ['', Validators.required],
      specialZone: ['']
    });

    this.designFormGroup = this.fb.group({
      // Pavement Design
      pavementType: ['', Validators.required],
      layerThicknesses: [null, Validators.required],
      materialSpecifications: ['', Validators.required],
    
      // Geometric Design
      horizontalAlignment: ['', Validators.required],
      verticalAlignment: ['', Validators.required],
      superelevation: [null, Validators.required],
      sightDistance: [null, Validators.required],
    
      // Drainage Design
      sideDrains: ['', Validators.required],
      crossDrainageStructures: ['', Validators.required],
      culvertsAndBridges: ['', Validators.required]
    });

    this.legalFormGroup = this.fb.group({
      // Land Acquisition
      landRequired: [null, [Validators.required, Validators.min(0.1)]],
      landAcquired: [null, [Validators.required, Validators.min(0)]],
      pendingAcquisitions: ['', Validators.required],
      compensationStatus: ['', Validators.required],
    
      // Environmental Clearances
      eiaStatus: ['', Validators.required],
      forestClearanceStatus: ['', Validators.required],
      wildlifeClearance: [''],
    
      // Utility Shifting
      electricalShift: ['', Validators.required],
      waterSupplyShift: ['', Validators.required],
      telecomShift: ['', Validators.required],
      gasLineShift: ['', Validators.required],
    
      // Other Clearances
      rowClearance: ['', Validators.required],
      localAuthorityPermission: ['', Validators.required]
    });
  
    this.stakeholdersForm = this.fb.group({
      projectOwner: ['', Validators.required],
      regulatoryBodies: ['', Validators.required],
      fundingAgencies: ['', Validators.required],
      localCommunities: ['', Validators.required],
      affectedOwners: ['', Validators.required]
    });

    this.projectTeamsForm = this.fb.group({
      planningTeam: this.fb.group({
        teamStructure: ['', Validators.required],
        roles: ['', Validators.required],
        contact: ['', [Validators.required, Validators.email]]
      }),
      designTeam: this.fb.group({
        designConsultants: ['', Validators.required],
        specializedConsultants: ['', Validators.required],
        contact: ['', [Validators.required, Validators.email]]
      }),
      fieldTeam: this.fb.group({
        teamStructure: ['', Validators.required],
        fieldEngineers: ['', Validators.required],
        supervisors: ['', Validators.required],
        contact: ['', [Validators.required, Validators.email]]
      }),
      testingTeam: this.fb.group({
        qcEngineers: ['', Validators.required],
        labs: ['', Validators.required],
        contact: ['', [Validators.required, Validators.email]]
      })
    });

    this.contractorsVendorsForm = this.fb.group({
      mainContractor: this.fb.group({
        companyName: ['', Validators.required],
        registrationNumber: ['', Validators.required],
        contactInfo: ['', [Validators.required, Validators.email]],
        performanceHistory: ['', Validators.required]
      }),
      subcontractors: this.fb.group({
        scopeOfWork: ['', Validators.required],
        companyDetails: ['', Validators.required],
        contactInfo: ['', [Validators.required, Validators.email]]
      }),
      materialSuppliers: this.fb.group({
        materialType: ['', Validators.required],
        supplierName: ['', Validators.required],
        qualityCerts: ['', Validators.required],
        contactInfo: ['', [Validators.required, Validators.email]]
      })
    });

    this.equipmentToolsForm = this.fb.group({
      heavyEquipment: this.fb.group({
        type: ['', Validators.required],
        makeModel: ['', Validators.required],
        capacity: ['', Validators.required],
        ownership: ['', Validators.required],
        maintenanceSchedule: ['', Validators.required]
      }),
      testingEquipment: this.fb.group({
        type: ['', Validators.required],
        calibrationStatus: ['', Validators.required],
        labCertification: ['', Validators.required]
      }),
      toolsInventory: this.fb.group({
        typeQuantity: ['', Validators.required],
        condition: ['', Validators.required],
        replacementSchedule: ['', Validators.required]
      })
    });

    this.projectControlsForm = this.fb.group({
      budget: this.fb.group({
        totalCost: [null, [Validators.required, Validators.min(0)]],
        costBreakdown: ['', Validators.required],
        fundingSources: ['', Validators.required],
        paymentSchedule: ['', Validators.required]
      }),
      schedule: this.fb.group({
        workBreakdownStructure: ['', Validators.required],
        milestoneDates: ['', Validators.required],
        criticalPath: ['', Validators.required]
      }),
      qualityControl: this.fb.group({
        testingFrequencies: ['', Validators.required],
        acceptanceCriteria: ['', Validators.required],
        qualityAssurancePlan: ['', Validators.required]
      }),
      riskManagement: this.fb.group({
        riskRegister: ['', Validators.required],
        mitigationStrategies: ['', Validators.required],
        contingencyPlans: ['', Validators.required]
      })
    });
    this.multiTenancyForm = this.fb.group({
      tenantId: ['', Validators.required],
      accessControlLevel: ['', Validators.required],
      dataSegregationRules: ['', Validators.required],
      tenantConfigurations: ['', Validators.required]
    });
  }

   onSubmit() {
    const projectData = {
      ...this.projectFormGroup.value,
      ...this.roadSpecsFormGroup.value,
      ...this.siteFormGroup.value,
      ...this.designFormGroup.value,
      ...this.legalFormGroup.value,
      ...this.stakeholdersForm.value,
      ...this.projectTeamsForm.value,
      ...this.contractorsVendorsForm.value,
      ...this.equipmentToolsForm.value,
      ...this.projectControlsForm.value,
      ...this.multiTenancyForm.value,
    };
    console.log('Submitted Project:', projectData);
    // Optionally send to backend
  }

}
